// =============================================================================
// features/dashboard/utils/cityOptions.ts — Opções do seletor de cidade.
//
// `leads.byCity` traz, além das cidades reais, a linha "Sem cidade" (leads sem
// city_id), identificada pelo UUID nil. Ela precisa aparecer no gráfico/tabela,
// mas NÃO pode virar opção do filtro: não é uma cidade, e filtrar por ela
// devolve zeros (a API responde 400 a esse id).
// =============================================================================

import type { LeadsByCityItem } from '../../../hooks/dashboard/types';

/**
 * Espelho de `NO_CITY_ID` exportado por apps/api/src/modules/dashboard/schemas.ts
 * (reexportado por repository.ts). O web não importa código da API; mantenha os
 * dois em sincronia.
 */
export const NO_CITY_ID = '00000000-0000-0000-0000-000000000000';

/** Cidades filtráveis a partir de `leads.byCity`: tudo, menos a linha "Sem cidade". */
export function buildCityOptions(byCity: readonly LeadsByCityItem[]): LeadsByCityItem[] {
  return byCity.filter((city) => city.cityId !== NO_CITY_ID);
}
